module.exports = __webpack_public_path__ + "static/media/Software-Defined-Parks.11c9802b.svg";